"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var languageSlice_1 = require("../../features/languages/languageSlice");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var RoomTourBanner = function () {
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.tour_banner, styles_module_scss_1.default['lang-' + currentLanguage]) }));
};
exports.default = RoomTourBanner;
